<style>
	.mw-h4{
		color: grey;
		font-size: 14px;
	}
.progress-wrapper{
		display: inline-block;
		margin-right: 15px;
		text-align: center;
	}
</style>
<template>
	<v-row>
		<v-col cols="12" md="5">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<h3 v-on="on" class="mw-h3 mb-2">
						Recruitment Status
					</h3>
				</template>
				<span>The charts below show progress of candidates by recruitment process step. Click here to find out more about our recruitment process</span>
			</v-tooltip>

			<div class="progress-wrapper">
				<v-progress-circular
				:size="100"
				:width="15"
				:value="count('status', 'Recruited') / total * 100"
				color="primary"
				>
				{{count('status', 'Recruited')}} / {{total}}
				</v-progress-circular><br/>
				<b class="overline">Recruited</b>
			</div>
			<div class="progress-wrapper">
				<v-progress-circular
				:size="100"
				:width="15"
				:value="count('status', 'Confirmed') / total * 100"
				color="green"
				>
				{{count('status', 'Confirmed')}} / {{total}}
				</v-progress-circular><br/>
				<b class="overline">Confirmed</b>
			</div>
		</v-col>
		<v-col cols="12" md="7">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<h3 v-on="on" class="mw-h3 mb-2">
						Status by {{prettyPrint(statFocus)}}
					</h3>
				</template>
				<span>The charts below display recruitment progress by main participant attributes or quotas. Use the drop down to select different criteria to display. Click here to find out more about how recruitment criteria are used</span>
			</v-tooltip>
				<div v-if="(statFocus == 'quota' || !toggleStatOptions) && project.quotas">
					<p class="mt-3" v-if="!toggleStatOptions"><v-chip>Quota</v-chip></p>
					<div class="progress-wrapper" v-for="(quota, index) in project.quotas" :key="index">
						<v-progress-circular
						:size="50"
						:width="6"
						:value="count('quota', quota) / total * 100"
						:color="colors[index]"
						>
						<small>{{count('quota', quota)}}</small>
						</v-progress-circular><br/>
						<b class="overline">{{prettyPrint(quota)}}</b>
					</div>
				</div>
				<div v-for="(key) in statOptions.filter(key => key !== 'quota')" :key="key">
					<p class="mt-3" v-if="!toggleStatOptions"><v-chip>{{prettyPrint(key, 'TITLE')}}</v-chip></p>
					<div v-if="key == statFocus || !toggleStatOptions">
						<div class="progress-wrapper" v-for="(option, index) in additionalFieldsOptions[key]" :key="index">
							<v-progress-circular
							:size="50"
							:width="6"
							:value="count(statFocus, option, true) / total * 100"
							:color="colors[index]"
							>
							<small>{{count(statFocus, option, true)}}</small>
							</v-progress-circular><br/>
							<b class="overline">{{prettyPrint(option)}}</b>
						</div>
					</div>
				</div>				
				<v-select v-if="statOptions && toggleStatOptions" v-model="statFocus" :items="statOptions"></v-select>
		</v-col>
	</v-row>
</template>

<script type="text/javascript">
	import Vuex from 'vuex';
	import {prettyPrint} from "../../assets/utilities.js";
	export default{
		name: "ProgressStats", 
		props: {
			project: {type: Object}, 
			toggleStatOptions: {type: Boolean, default: true }
		},
		data: () => {
			return {
				statFocus: 'quota', 
			}
		},
		computed: {
			...Vuex.mapState({
				view: (state) => state.auth.view,
				admins: (state) => state[state.auth.view].admins,
				clients: (state) => state[state.auth.view].clients,
				colors: (state) => state.settings.colors,
				appointments: function(state){
					let projectId = this.project.id
					if( !state[state.auth.view] ){
						return;
					}
					return state[state.auth.view].appointments.filter(a => a.project == projectId)
				},
			}),
			total: function(){
				if( !this.appointments ){
					return 1;
				}
				return this.appointments.length
			},
			statOptions: function(){
				let options = [];
				if( this.project.quotas ){ options.push('quota') } 
				if( this.project.additionalFields ){ this.project.additionalFields.forEach( field => options.push(field) ) } 
				if( options.length == 0 ){ return false; }
				return options;
			}, 
			additionalFieldsOptions: function(){
				const self = this;
				if( !self.project.additionalFields ){ return { } }
				let responses = {}
				self.project.additionalFields.forEach( p => responses[p] = [] )
				self.appointments.forEach( a => {
					self.project.additionalFields.forEach( field  => {
						if( a[field] && responses[field].indexOf(a[field]) < 0 ){
							responses[field].push( a[field ])
						}
					} )
				})
				return responses;
			}
		},
		methods: {
			prettyPrint: prettyPrint,
			count: function(key, value, additionalFields=false){
				let count = this.appointments.filter( (a) => {
					if( additionalFields ){ return a[key] == value }
					return a[key] == value
				})
				return count.length;
			},
		}

	}
</script>